// eslint-disable-next-line import/no-extraneous-dependencies
import * as _history from "history";

export default _history.createBrowserHistory();
